import { AgGridReact } from "ag-grid-react";
import { useRef, useState } from "react";
import { Theme, themeQuartz } from "ag-grid-community";
import React, { useEffect, useMemo } from 'react';
import { titleCell } from "../../../../components/elements/function";
import Icon from "../../../../components/icons";
import Loader from "../../../../components/loader";
import { useParams } from "react-router-dom";
import { useDepreciationApi } from "../../../../store/api/hooks/depreciationApiHook";
import moment from "moment";
import { DATE_FORMAT } from "../../../../_common/constant";
import Button from "../../../../components/elements/button";
import { useSagesApi } from "../../../../store/api/hooks/sageApiHook";
import toast from "react-hot-toast";
import AssetDisposalModalWrapper from "./assetDisposalModalWrapper";
import Currency from "../../../../components/currency";
interface Props {
  _ref: any;
  hasPermission?: boolean;
  onDataChange?: (assetID?: any) => void;
}
const AssetDisposal: React.FC<Props> = ({ _ref, hasPermission = true, onDataChange }) => {
  const myTheme = themeQuartz.withParams({
    headerBackgroundColor: `#F0F0F0`
  });
  const theme = useMemo<Theme | "legacy">(() => {
    return myTheme;
  }, []);
  const params: any = useParams();
  const [rowData, setRowData] = React.useState<any[] | null>([]);
  const depreciationAPI = useDepreciationApi();
  const [loadingRowId, setLoadingRowId] = React.useState<string | null>(null);
  const sageApi: any = useSagesApi();
  const AssetDisposalModalRef = useRef<any>(null);
  const [selectedItem, setSelectedItem] = useState<string | null>(null);

  const columnDefs = [
    {
      headerName: "Disposal Date",
      field: "disposalDate",
      headerClass: "bg-[#f0f0f0]",
      width: 300,
      cellRenderer: (data: any) => data.value ? moment(data.value).format(DATE_FORMAT) : '--'
    },
    {
      headerName: "Disposal Type",
      field: "disposalTypeName",
      headerClass: "bg-[#f0f0f0]",
      width: 300,
      cellRenderer: titleCell,
    },
    {
      headerName: "Asset ID",
      field: "assetCode",
      headerClass: "bg-[#f0f0f0]",
      width: 300,
      cellRenderer: titleCell,
    },
    {
      headerName: "Sales Amount",
      field: "saleAmount",
      headerClass: "bg-[#f0f0f0] ag-right-aligned-header",
      width: 300,
      cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) => <Currency currency="USD" value={data.value} />
    },
    {
      headerName: "Notes",
      field: "notes",
      headerClass: "bg-[#f0f0f0]",
      width: 300,
      cellRenderer: titleCell,
    },
    {
      headerName: "Added Date",
      field: "addedDate",
      headerClass: "bg-[#f0f0f0]",
      width: 300,
      cellRenderer: (data: any) => data.value ? moment(data.value).format(DATE_FORMAT) : '--'
    },
    {
      headerName: "Added By",
      field: "addedByName",
      headerClass: "bg-[#f0f0f0]",
      width: 300,
      cellRenderer: (data: any) => <p>{data.value}</p>,
    },
    /* { headerName: 'Sage Doc No', field: 'sageDocNo', headerClass: 'bg-[#f0f0f0]', flex: 1, width: 120, cellRenderer: (data: any) => data.value ? data.value : '--' },
    { headerName: 'Sage Posting Date', field: 'sagePostingDate', headerClass: 'bg-[#f0f0f0]', minWidth: 140, flex: 1, cellRenderer: (data: any) => data.value ? moment(data.value).format(DATE_FORMAT) : '--' }, */
    /* {
      headerName: "Action",
      field: "sageDocument",
      headerClass: "bg-[#f0f0f0]",
      width: 200,
      cellRenderer: (params: any) => {
        const { sageDocNo, assetDisposalID, disposalDate } = params.data;

        const isFutureYear =
          disposalDate && moment(disposalDate).year() > moment().year();

        const isDisabled =
          !!sageDocNo || loadingRowId === assetDisposalID || isFutureYear || !hasPermission;

        return (
          <div className="flex items-center justify-between">
            <Button
              disabled={isDisabled}
              onClick={() => {
                setSelectedItem(params.data);
                AssetDisposalModalRef.current?.show();
              }}
            >
              {sageDocNo
                ? "Posted"
                : loadingRowId === assetDisposalID
                  ? "Posting..."
                  : "Post To Sage"}
            </Button>
          </div>
        );
      }

    } */
  ];

  const GetDisposalList = (assetID: any = params.id) => {
    const payload = {
      assetID: assetID,
    };
    depreciationAPI.GetDisposalList(
      payload,
      (data: any) => {
        setRowData(data.disposalList);
        // Notify parent component about data change
        if (onDataChange) {
          onDataChange(assetID);
        }
      },
      (error: any) => { }
    );
  };

  useEffect(() => {
    if (params.id) {
      GetDisposalList(params.id);
    }
  }, [params]);

  useEffect(() => {
    if (_ref?.current) {
      _ref.current.reload = GetDisposalList;
    }
  }, [_ref]);

  return (
    <div ref={_ref}>

      <div className="flex items-center justify-between h-[60px]">
        <h4 className="font-semibold text-[0.938rem]">Asset Disposal</h4>
      </div>
      <div className={`mb-3 ag-theme-alpine overflow-auto ${!rowData || rowData.length === 0 || rowData.length <= 2 ? 'h-[150px]' : 'h-[300px]'}`}>
        <AgGridReact
          theme={theme}
          columnDefs={columnDefs}
          rowData={rowData || []}
          pagination={false}
          domLayout="normal"
          ensureDomOrder={true}
          suppressHorizontalScroll={true}
          loadingOverlayComponent={Loader}
          noRowsOverlayComponent={() => (
            <div className="flex items-center justify-center h-full">
              <div className="text-center text-gray-500">
                <div className="text-lg font-medium">No Data Found</div>
              </div>
            </div>
          )}
        />
      </div>
      <AssetDisposalModalWrapper
        ref={AssetDisposalModalRef}
        item={selectedItem}
        onRefresh={() => GetDisposalList(params.id)} // pass this new prop
      />
    </div>
  );
};

export default AssetDisposal;
